export default "__VITE_ASSET__D2E42JlX__"